import React from 'react'
import { Tabs, Modal, Space, Input, message } from 'antd';
import Config from "../../../config/Config";
import WidgetAjax from '../../../widget/WidgetAjax';
import WidgetTable from '../../../widget/WidgetTable';
// import { TMap, MultiMarker } from '@map-component/react-tmap';
import Map from '../../com/map/index';
const { Search } = Input;
let filePath = Config.getFilePath();
let path = Config.getBasePath();
class interview extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      jobState: [
        { label: "未查看", key: "0" },
        { label: "已查看", key: "1" },
        { label: "待面试", key: "11" },
        { label: "已拒绝", key: "12" },
        { label: "已结束", key: "13" },
        { label: "已过期", key: "14" }
      ],
      tabValue: "0",
      filter: { effective: true, CONFIRM: ["0"] },
      source: ["1"],
      tableOptions: {
        records: 10,
        check: {
          key: 'id',
          enable: true
        }
      },
      page: 1,
      columns: [
        { "name": "INTVTIME", "title": "邀请时间", "type": "string", properties: {} },

        { "name": "JOBNAME", "title": "邀请岗位", "type": "string", properties: { transform: "JOBTYPE" } },
        { "name": "ENTNAME", "title": "企业名称", "type": "string", properties: {} },
        { "name": "DISTRICT_CN", "title": "区域", "type": "string", properties: {} },
        { "name": "operate", "title": "操作", "type": "string", properties: { transform: 'operate', width: '230px' } },
      ],
      data: [],
      word: undefined,
      loading: true,
      confirmModal: {
        open: false,
        title: "接受邀请",
        data: {}
      },
      interviewModal: {
        open: false,
        data: {}
      }
    }
  }
  componentDidMount() {
    this.loadData();
  }

  tabChange = async (value) => {
    this.setState({ tabValue: value });
    let obj = { filter: { effective: true, CONFIRM: ["0"] } };
    switch (value) {
      case "0":
        obj = { effective: true, CONFIRM: ["0"] }
        break;
      case "1":
        obj = { effective: true, CONFIRM: ["2"] }
        break;
      case "11":
        obj = { effective: true, CONFIRM: ["1"] }
        break;
      case "12":
        obj = { effective: true, CONFIRM: ['6', '9'] }
        break;
      case "13":
        obj = { effective: false, CONFIRM: ['1', '6', '9'] }
        break;
      case "14":
        obj = { effective: false, CONFIRM: ['0', '2'] }
        break;
    }
    await this.setState({ filter: obj })
    this.loadData();
  }

  onSearch = async (value) => {

    await this.setState({ word: value, data: [], page: 1 });
    this.loadData();
  }

  onSource = async (value) => {
    await this.setState({ source: [value], data: [], page: 1 });
    this.loadData();
  }



  /**
* 分页
* @param {} page 
* @param {*} pageSize 
*/
  onChangePage = async (page, pageSize) => {
    const { tableOptions } = this.state;
    await this.setState({ page, tableOptions: { ...tableOptions, records: pageSize } })
    this.loadData();
  }

  /**
* 表格数据
* @param {*} PAGES 
*/
  loadData = () => {
    const { page, tableOptions, source, filter, word } = this.state;
    let params = {
      ...filter,
      word,
      source,
      page,
      records: tableOptions.records
    }
    this.setState({ loading: true })


    const onLoadData = (res) => {
      if (res.status === 0) {
        this.setState({ data: res.results, total: res.total });
      }
      else {
        this.setState({ data: [], total: 0 })
      }
      this.setState({ loading: false })
    }

    WidgetAjax.ajax({ url: path + '/job/interview_list', params, callback: onLoadData });
  }

  notify = (type, record) => {
    const { tabValue } = this.state
    switch (type) {
      case 'check':
        this.setState({ checkList: record });
        break;
      case 'JOBTYPE':
        {
          return record?.JOBTYPE_CN ?
            <div className='table_operation'>
              <a className='affirm' onClick={() => this.info(record?.id)}>{record?.JOBTYPE_CN}</a>

            </div> : "-"
        }
      case "operate":
        {
          return tabValue === '0' || tabValue === '1' ?
            <div className='table_operation'>
              <a className='affirm' onClick={() => this.confirm([record?.id], "1")}>接受邀请</a>
              <a onClick={() => this.confirm([record?.id], "6")}>拒绝邀请</a>
            </div> : "-"
        }
    }
  }


  confirm = (ids, type) => {
    let params = {
      ids,
      CONFIRM: type
    }
    const onConfirm = async (res) => {
      if (res.status == 0) {
        message.success("成功");
        this.setState({ checkList: [] });
        this.setState({ interviewModal: { open: false, data: {} } })
        await this.ModalCancel();
        this.loadData();
      } else {
        message.success("失败" + res.message);
      }

    }
    WidgetAjax.ajax({ url: path + '/job/interview_confirm', params, callback: onConfirm });
  }

  inquiry = (type) => {
    const { checkList, confirmModal } = this.state;
    if (checkList && checkList.length > 0) {
      this.setState({
        confirmModal: {
          ...confirmModal,
          open: true,
          title: type === "1" ? '接受邀请' : '拒绝邀请',
          data: { type },
          message: "你选择了" + checkList.length + "条数据,确认" + (type === "1" ? '接受邀请' : '拒绝邀请') + "吗？"
        }
      })

    } else {
      message.info("请先选择数据!");
    }
  }

  ModalCancel = () => {
    const { confirmModal } = this.state;
    this.setState({
      confirmModal: {
        ...confirmModal,
        open: false,
      }
    })
  }

  info = (id) => {
    const onInfo = async (res) => {
      if (res.status == 0) {
        await this.setState({ interviewModal: { open: true, data: res.result } });
      } else {
        message.info("请重试!" + res.message)
      }
    }
    WidgetAjax.ajax({ url: path + '/job/interview_info', params: { id }, callback: onInfo });
  }



  render() {
    const { jobState, tabValue, source, columns, tableOptions, data, loading, page, total, confirmModal, checkList, interviewModal } = this.state;
    const ent_info = interviewModal?.data
    return <div>
      <div className='tab_title'>面试通知</div>
      <div className='tab_tabs'>
        <Tabs items={jobState} value={tabValue} onChange={this.tabChange} />
        <div className='operation'>
          <div className={source[0] === '1' ? 'groupBtn groupBtns' : 'groupBtn'} onClick={() => this.onSource("1")}>我投递的</div>
          <div className={source[0] === '2' ? 'groupBtn groupBtns' : 'groupBtn'} onClick={() => this.onSource("2")}>他人邀请</div>
          <Search placeholder="搜索岗位名称" onSearch={this.onSearch} style={{ width: 200 }} />
        </div>
      </div>
      <div className='table'>
        <div className='check_operation'>
          <div className='btn take' onClick={() => { this.inquiry("1") }}>接受邀请</div>
          <div className='btn' onClick={() => { this.inquiry('6') }}>拒绝邀请</div>
        </div>
        <WidgetTable data={data} columns={columns} options={tableOptions} loading={loading} page={page} notify={this.notify} pageTurning={this.onChangePage} total={total} />
      </div>

      {
        <Modal
          title={confirmModal?.title}
          open={confirmModal?.open}
          onOk={() => this.confirm(checkList, confirmModal?.data.type)}
          onCancel={this.ModalCancel}>

          <p>{confirmModal?.message}</p>
        </Modal>
      }

      {
        <Modal
          title={"面试邀约详情"}
          open={interviewModal?.open}
          onCancel={() => { this.setState({ interviewModal: { ...interviewModal, open: false } }) }}
          footer={null}
        >
          <div className='interviewModal'>
            <div className="company-header">
              <img class="sg-ENTImg" src={ent_info?.ENTLOGO ? filePath + 'enterprise/M' + ent_info?.enterprise_id + '.png' : require('../../../img/pinzhunzhun/dataSource/ent_logo.png')} />
              <div className='company-infos'>
                <div className='company-name'>{ent_info?.ENTNAME}</div>
                <div className='company-type'>
                  <div>{ent_info?.INDTYPE_CN ? ent_info?.INDTYPE_CN : null}</div>
                  <div>{ent_info?.SCALE_CN ? ent_info?.SCALE_CN : null}</div>
                  <div>{ent_info?.ENTTYPE_CN ? ent_info?.ENTTYPE_CN : null}</div>
                </div>
              </div>
            </div>
            < p class="int_field">面试时间：<label>{ent_info.INTVTIME}</label></ p>
            < p class="int_field">面试岗位：<label>{ent_info.JOBTYPE_CN}</label></ p>
            < p class="int_field">联系人：<label>{ent_info.INTVCONTACT} {ent_info.INTVCONTACTTEL}</label></ p>
            < p class="int_field">面试备注：<label>{ent_info.INTVCOMMENT}</label></ p>
            < p class="int_field">面试地址：<label>{ent_info.INTVADDR}</label></ p>
            {
              ent_info?.LOCATION?.ADDRESS ?
                <Map lat={ent_info?.LOCATION?.ADDRESS?.LAT} lng={ent_info?.LOCATION?.ADDRESS?.LNG} />
                : null
            }
            <div className='footer-btn'>
              <div className='check_operation'>
                <div className='btn take' onClick={() => { this.confirm([interviewModal?.data?.id], "1") }}>接受邀请</div>
                <div className='btn' onClick={() => { this.confirm([interviewModal?.data?.id], "1") }}>拒绝邀请</div>
              </div>
            </div>
          </div>
        </Modal>
      }
    </div>
  }
}

export default interview;